module.exports = false;



//////////////////
// WEBPACK FOOTER
// /code/frontend/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0